import cn from 'classnames'

import { STATUS_TO_VARIANT } from 'partner360/features/mdfActivities/lib'

import styles from './StatusBadge.module.scss'

interface IStatusBadgeProps {
  status: string | null
}

export const StatusBadge = ({ status }: IStatusBadgeProps) => {
  if (!status) {
    return <span className={styles.empty}>—</span>
  }

  const variant = STATUS_TO_VARIANT[status.trim().toLowerCase()] ?? 'planning'

  return (
    <span className={cn(styles.badge, styles[variant])}>
      <span className={styles.dot} />
      {status}
    </span>
  )
}

StatusBadge.displayName = 'StatusBadge'
